import React from 'react';
import SvgIcon from './SvgIcon';

const AccountSettings = props => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M3.06 23.06a1.5 1.5 0 01-2.121-2.12l6.57-6.573 2.122 2.122-6.571 6.57zM6.451 13.306l4.24 4.243M19.91 4.101L8.572 15.428M21.785 4.359a1 1 0 01-1.508.109l-.812-.811a1 1 0 01.135-1.529L21.816.589a.5.5 0 01.639.057l.9.9a.5.5 0 01.045.654l-1.615 2.159zM11.586 9.586l-3.44-3.44A4 4 0 003.678.584a.5.5 0 00-.251.843l1.427 1.427A.5.5 0 015 3.207V4.5a.5.5 0 01-.5.5H3.207a.5.5 0 01-.353-.146L1.427 3.427a.5.5 0 00-.843.251 4 4 0 005.562 4.468l3.44 3.44M14.414 12.414l3.44 3.44a4.001 4.001 0 015.562 4.468.5.5 0 01-.843.25l-1.427-1.426a.5.5 0 00-.353-.146H19.5a.5.5 0 00-.5.5v1.293a.5.5 0 00.146.353l1.427 1.427a.501.501 0 01-.25.843 4 4 0 01-4.468-5.562l-3.44-3.44"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

AccountSettings.displayName = 'AccountSettingsIcon';

export default AccountSettings;
